'use strict';

// @MAJOR can be replaced by native Array#findIndex when we change support
module.exports = function find(array, comparator) {
  if (!Array.isArray(array)) {
    return -1;
  }

  for (var i = 0; i < array.length; i++) {
    if (comparator(array[i])) {
      return i;
    }
  }
  return -1;
};



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/src/functions/findIndex.js
// module id = 55
// module chunks = 0